import {reactive, computed} from "ui.vue3";
import {useRoute} from 'ui.vue3.router';
import {useCoursesStore} from "../../stores/courses";

export const CategoryGoCurses = {
    components: {},
    setup() {
        const route = useRoute();
        console.log(route.params)
        const courseStore = useCoursesStore();
        courseStore.filters = {
            tag: route.params.go
        }
        courseStore.fetchCourses();

        const lists = computed(() => courseStore.list)


        return { lists }
    },
    template: `
<div class="row g-4 justify-content-center" id="popular-courses">
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s" v-for="(course, index) in lists" :key="index">
                <div class="course-item bg-light">
                    <div class="position-relative overflow-hidden">
                        <img class="img-fluid" :src="course.PHOTO" alt="">
                        <div class="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                            <a :href="'/courses/' + course.GROUP_CODE + '/' + course.CODE" class="flex-shrink-0 btn btn-sm btn-primary px-3 border-end" style="border-radius: 30px 0 0 30px;">Подробнее</a>
                            <a href="#" class="flex-shrink-0 btn btn-sm btn-primary px-3" style="border-radius: 0 30px 30px 0;">Купить</a>
                        </div>
                    </div>
                    <div class="text-center p-4 pb-0">
                        <h3 class="mb-0">{{course.PRICE}} rub</h3>
                        <div class="mb-3">
                            <small class="fa fa-star text-warning"></small>
                            <small class="fa fa-star text-warning"></small>
                            <small class="fa fa-star text-warning"></small>
                            <small class="fa fa-star text-warning"></small>
                            <small class="fa fa-star text-primary"></small>
                            <small>(4,6)</small>
                        </div>
                        <h5 class="mb-4">{{course.NAME}} & {{course.GROUP_NAME}} & {{course.LEVEL_NAME}}</h5>
                    </div>
                    <div class="d-flex border-top">
                        <small class="flex-fill text-center border-end py-2"><i class="fa fa-user-tie text-primary me-2"></i>{{course.USER_NAME}} {{course.USER_LAST_NAME}}</small>
                        <small class="flex-fill text-center border-end py-2"><i class="fa fa-clock text-primary me-2"></i>1.49 Hrs</small>
                        <small class="flex-fill text-center py-2"><i class="fa fa-user text-primary me-2"></i>30 Students</small>
                    </div>
                </div>
            </div>
        </div>
    `
}